export default __webpack_public_path__ + "static/media/AssignmentIcon.dabc5927.svg";